export default __webpack_public_path__ + "static/media/cursedbyheavens.c8c9ecac.png";